<template>
  <footer ref="foot">
    <hr>
    <div class="wrapper">
      <div class="logo">
        <carify-logo></carify-logo>
        <ul class="social">
          <li><a :href="blok.facebook_link" target="_blank" aria-label="Facebook Page"><cms-social-icons icon="facebook"></cms-social-icons></a></li>
          <li><a :href="blok.instagram_link" target="_blank" aria-label="Instagram Page"><cms-social-icons icon="instagram"></cms-social-icons></a></li>
          <li><a :href="blok.linkedin_link" target="_blank" aria-label="LinkedIn Page"><cms-social-icons icon="linkedin"></cms-social-icons></a></li>
          <li><a :href="blok.youtube_link" target="_blank" aria-label="Youtube Page"><cms-social-icons icon="youtube"></cms-social-icons></a></li>
          <li><a :href="blok.tiktok_link" target="_blank" aria-label="TikTok Page"><cms-social-icons icon="tiktok"></cms-social-icons></a></li>
        </ul>
        <form ref="form">
          <p><translate>Subscribe to our newsletter</translate></p>
          <div class="group">
            <input type="email" required :placeholder="$gettext('Enter your email')" v-model="email" ref="email">
            <button @click="postEmail" :disabled="busy"><translate>Subscribe</translate></button>
          </div>
          <p class="thanks" v-show="thanking"><translate>Thanks for Signing up to our newsletter!</translate></p>
        </form>
      </div>

      <div class="pillar">
        <p class="column">{{ blok.first_column_title }}</p>
        <ul>
          <li v-for="l in blok.first_column_links" :key="l._uid">
            <b-link class="link" :to="buildURL(l.link)">
              {{ l.text }}
            </b-link>
          </li>
        </ul>
      </div>

      <div class="pillar">
        <p class="column">{{ blok.second_column_title }}</p>
        <ul>
          <li v-for="l in blok.second_column_links" :key="l._uid">
            <b-link class="link" :to="buildURL(l.link)">
              {{ l.text }}
            </b-link>
          </li>
        </ul>
      </div>

      <div class="pillar">
        <p class="column">
          {{ blok.contact_title }}
        </p>
        <ul>
          <li>
            <b-link class="link" :to="`/${$language.current}/contact-us`">
              <translate>Contact Us</translate>
            </b-link>
          </li>
          <li class="icon-ff">
            <cms-material-icon class="accent" size="normal" icon="email"></cms-material-icon>
            <span>
              Email: <br>
              <a class="link" :href="`mailto:${blok.contact_email}`">{{ blok.contact_email }}</a>
            </span>
          </li>
          <li class="icon-ff">
            <cms-material-icon class="accent" size="normal" icon="call"></cms-material-icon>
            <span>
              {{ blok.customer_title }}<br>
              <a class="link" :href="`tel:${blok.customer_phone}`">{{ blok.customer_phone }}</a>
            </span>
          </li>
          <li class="icon-ff">
            <cms-material-icon class="accent" size="normal" icon="call"></cms-material-icon>
            <span class="v">
              {{ blok.garage_title }}<br>
              <a class="link" :href="`tel:${blok.garage_phone}`">{{ blok.garage_phone }}</a>
            </span>
          </li>
          <li class="icon-ff">
            <cms-material-icon class="accent" size="normal" icon="location_pin"></cms-material-icon>
            <span class="v">
              <a class="link" href="https://goo.gl/maps/qqnzopHvDqW1ciFk9" target="_blank">
                {{ blok.contact_address }} <br> {{ blok.contact_canton }}
              </a>
            </span>
          </li>
          <li class="icon-ff">
            <WhatsAppIcon/>
            <span class="v">
              WhatsApp<br>
              <a class="link" target="_blank" :href="blok.whatsapp_url">{{ blok.whatsapp_number }}</a>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <hr>
    <div class="end">
        <div>
          <img loading="lazy" class="tiny-img mr-2" alt="Swiss Made Software" :src="require('@/assets/images/swiss_made_software.png')" />
          <img loading="lazy" class="tiny-img" alt="Spin Off" :src="require('@/assets/images/spin_off.png')" />
        </div>
        <p class="shrink">&copy; {{ new Date().getFullYear() }} CARIFY. All rights reserved.</p>
        <b-link class="link shrink" :to="`/${$language.current}/terms-and-conditions`"><translate>Terms & Conditions</translate></b-link>
        <b-link class="link shrink" :to="`/${$language.current}/privacy-policy`"><translate>Privacy Policy</translate></b-link>
        <b-link class="link shrink" :to="`/${$language.current}/impressum`"><translate>Imprint</translate></b-link>
        <cms-lang-switch style="justify-self: en2d;"></cms-lang-switch>
    </div>

  </footer>
</template>

<script>
export default {
  name: "cms-footer",
  data() {
    return {
      email: "",
      busy: false,
      thanking: false,
      blok: {},
    }
  },
  async fetch() {
    await this.fetchFooterData();
  },
  watch: {
    $route(to, from) {
      if (to.params.language !== from.params.language) {
        this.fetchFooterData();
      }
    },
  },
  methods: {
    subscribed() {
      this.email = "";
      this.busy = false;
      this.thanking = true;
      setTimeout(() => {
        this.thanking = false;
      }, 2000);
    },
    async postEmail() {
      if (!this.$refs.email.checkValidity()) {
        this.$refs.form.reportValidity();
        return;
      }
      this.busy = true;
      let hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/, "$1");
      let args = { email: this.email, first_name: "", last_name: "", type: "footer" };
      if (hutk) {
        args["hutk"] = hutk;
      }
      this.$api
        .post("public_api/users/newsletter_signup/", args)
        .then(this.subscribed)
        .catch((error) => {
          this.email = "";
          this.busy = false;
        });
    },
    async fetchFooterData() {
      const version = this.$config.STORYBLOK_VERSION
      const language = this.$route.params.language.replace("de", "de_CH")
      const { data } = await this.$sb.get(`cdn/stories/cms-footer`, { version, language });
      this.blok = data.story.content;
    },
    buildURL(link) {
      const clean = link.cached_url.replace("/de-CH/", "").replace("/fr/", "").replace("/it/", "").replace("en/", "");
      return `/${this.$route.params.language}/${clean}`
    },
  }
}
</script>

<style scoped>
.icon-ff {
  display: flex;
  gap: 4px;
}

.icon-ff .accent {
  align-self: stretch;
  flex: 0 0 auto;
}

.icon-ff .v {
  flex: 1 1 auto;
}

footer {
  padding-bottom: 1.2rem;
  box-sizing: border-box;
  background: var(--crf-temp-foot-bg, #fff);
  color: var(--crf-text, #000);
  font-family: var(--crf-ff);
}

hr {
  height: 0;
  margin: 0;
  border-top: 1px solid var(--crf-border, #dedede);
}

p.column {
  font-family: var(--crf-ff-head);
  font-weight: 500;
  font-size: 0.9rem;
  margin: 0 0 0.5rem 0;
  padding: 0;
  color: var(--crf-flip);
}

footer div.wrapper {
  padding-block: 1rem;
  --gap: clamp(1rem, 6vw, 3rem);
  margin: 0 auto;
  width: min(65rem, 100% - var(--gap) * 2);
  display: grid;
  gap: 1rem;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

ul li {
  font-size: 0.85rem;
}

.shrink {
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
}

ul.social {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  margin-left: 4px;
  justify-content: center;
}

div.logo {
  text-align: center;
}

div.pillar ul {
  display: grid;
  gap: 0.25rem;
}

div.end {
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  margin-inline: auto;
  width: min(100% - 3rem, 65rem);
  gap: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}


form {
  margin: 1rem 0 0 0;
  padding: 0;
  margin-inline: auto;
}

form div.group {
  overflow: hidden;
  max-width: 80%;
  margin: 0 auto;
  border-radius: 20px;
  display: grid;
  grid-template-columns: 1fr 85px;
  background-color: #fff;
  border: 1px solid var(--crf-border);
}

form p {
  margin: 0;
  padding: 0.5rem;
  font-size: 0.85rem;
  font-family: Inter;
}

form p.thanks {
  font-family: "Open Sans";
  font-size: 0.70rem;
  font-style: italic;
  color: var(--crf-primary);
}

form input {
  background-color: transparent;
  font-size: 0.8rem;
  outline: none;
  border: none;
  padding: 0 0.75rem;
}

form button {
  background-color: var(--crf-accent);
  color: var(--crf-bg-high);
  padding: 0.5rem;
  outline: none;
  border: none;
  font-size: 0.8rem;
  border-radius: 20px;
}

form button[disabled] {
  background-color: var(--crf-tx-dis);
  cursor: not-allowed;
}

@media screen and (min-width: 412px) {
  div.pillar ul {
    gap: 0.45rem;
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (min-width: 768px) {
  div.pillar ul {
    gap: 0.45rem;
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (min-width: 999px) {
  ul.social {
    justify-content: start;
    margin-left: 4px;
  }

  div.end {
    flex-direction: row;
  }

  div.logo {
    text-align: left;
  }

  footer div.wrapper {
    /* grid-template-columns: repeat(4, 1fr); */
    grid-template-columns: 300px 1fr 1fr 1fr;
  }

  form div.group {
    max-width: 95%;
    margin: 0;
  }

  div.pillar ul {
    gap: 0.45rem;
    grid-template-columns: 1fr;
  }
}

a.link {
  color: var(--crf-text);
  text-decoration: none;
}

a.link:hover {
  color: var(--crf-accent);
  text-decoration: underline;
}

a.link.router-link-active {
  color: var(--crf-accent);
  font-weight: 600;
}

a.link.router-link-active:hover {
  text-decoration: none;
  cursor: default;
}

.tiny-img {
  max-height: 22px;
  display: inline-block;
}

.lang-switch {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  font-size: 2rem;
}

.lang-switch li {
  cursor: pointer;
  font-size: 1.5rem;
}
</style>
